module.exports = __webpack_public_path__ + "img/iosdown1.5524f5fd.png";